import React from 'react';
import { Form } from 'react-bootstrap';
import ComboBoxField from './ComboBoxField';
import '../App.css';

function FormField({ field, value, on_change }) {
	if(field.type === 'textarea') {
		return (
			<Form.Group className="admin-form-group">
				<Form.Label className="admin-form-label">{field.label}</Form.Label>
				<Form.Control
					as="textarea"
					rows={3}
					className="admin-form-control"
					value={value || ''}
					onChange={function(e) { return on_change(field.key, e.target.value); }}
				/>
			</Form.Group>
		);
	}

	if(field.type === 'select') {
		return (
			<Form.Group className="admin-form-group">
				<Form.Label className="admin-form-label">{field.label}</Form.Label>
				<Form.Select
					className="admin-form-control"
					value={value || ''}
					onChange={function(e) { return on_change(field.key, e.target.value); }}>
					{field.options.map(function(opt) {
						return <option key={opt} value={opt}>{opt}</option>;
					})}
				</Form.Select>
			</Form.Group>
		);
	}

	if(field.type === 'datalist') {
		return <ComboBoxField field={field} value={value} on_change={on_change} />;
	}

	return (
		<Form.Group className="admin-form-group">
			<Form.Label className="admin-form-label">{field.label}</Form.Label>
			<Form.Control
				type={field.type}
				className="admin-form-control"
				value={value || ''}
				onChange={function(e) { return on_change(field.key, e.target.value); }}
			/>
		</Form.Group>
	);
}

export default FormField;
